import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
html {
	font-size : 30px;
	@media (max-width : 1024px){
		font-size: 25px;
	}
	@media (max-width : 768px){
		font-size: 22px;
	}
}

body {
	font-family: 'Grotta', sans-serif;
	color : ${props=>props.theme.textColor_base};
	overflow-x: hidden;
	-webkit-user-select:none; -moz-user-select:none; -ms-user-select:none; user-select:none
}
svg{
	@media (max-width : 1024px){
		transform: scale(0.8);
	}
	@media (max-width : 768px){
		font-size: scale(0.6);
	}
}

ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
a{
	color : inherit;
    text-decoration: none;
	cursor: pointer;
}

`;

export default GlobalStyle;